
function evlink(l, evnum, lnkn, pnum, pval, eVarNum, eVarVal) {

    var category; var action; var label;
    switch (evnum) {
        case 1: category='Video'; action='View'; label='Video Time View';break;
        case 2: category='Video'; action='View'; label='Video Views';break;
        case 3: category='Video'; action='View'; label='Video Completes';break;
        case 4: category='Video'; action='View'; label='Video Segment';break;
        case 10: category='Video'; action='Share'; label='Video Share';break;
        case 14: category='Search '; action='Null Search'; label='(search term here)';break;
        case 16: category='Video'; action='View'; label='Video Completes';break;
        case 17: category='Video'; action='View'; label='Video 25%';break;
        case 18: category='Video'; action='View'; label='Video 50%';break;
        case 19: category='Video'; action='View'; label='Video 75%';break;
        case 20: category='RFP'; action='Click'; label='RFP Request';break;
        case 21: category = 'Luxury Centers'; action = 'Scroll Button Tab'; label = trackingPageName; break;
        case 33: category='ION'; action='Abandon'; label='';break;
        case 34: category='ION'; action='Show '; label='';break;
        case 35: category='ION'; action='Close'; label='';break;
        case 49: category='eNL SignUp'; action='Click'; label='Banner Module Sign Up Click';break;
        case 50: category='eNL SignUp'; action='Click'; label='Newsletter Module Sign Up Click';break;
        case 51: category='eNL SignUp'; action='View'; label='Newsletter Page View';break;
        case 52: category='eNL SignUp'; action='Click'; label='Newsletter Page Sign Up Click';break;
        case 53: category='eNL SignUp'; action='Click'; label='Register Link Click';break;
        case 54: category='eNL SignUp'; action='Click'; label='Mini-Reg - Submit Click';break;
        case 55: category='eNL SignUp'; action='View'; label='Mini-Reg thank you message – new user';break;
        case 56: category='eNL SignUp'; action='View'; label='Thank you message – existing user not activated';break;
        case 57: category='eNL SignUp'; action='Click'; label='Register Validation';break;
        case 58: category='eNL SignUp'; action='View'; label='Thank You Message – existing user';break;
        case 59: category='eNL SignUp'; action='View'; label='Mini-reg complete- validation Custom 59';break;
        case 60: category = 'eNL SignUp'; action = 'Click'; label = 'Mini-Reg page – multi Submit Click'; break;
        case 75: category = 'RecommendWidget'; action = 'Recommend widget'; label = ''; break;
            //ajax action
    }


    gaEvent(category, action, label)

    if ((pnum != 'undefined' && pval != 'undefined' && pval != null && pval != '' && pnum != null && pnum != '0')) {
        if (pnum == 71) { gaEvent("eNL sign up", "Registration Source", pval) }
        if (pnum == 72) { gaEvent("eNL sign up", "Sign Ups", pval) }
        }

}

function gaEvent(category,action, label) {
    if (ga && category!="") { ga('send', 'event', category, action, label); }
}

function ntmtrk_printsub_start(){evlink('true','11','Print Registration Start');}
function ntmtrk_printsub_end(){evlink('true','12','Print Registration Complete');}
function ntmtrk_esub_start(){evlink('true','8','Web Registration Start');}
function ntmtrk_esub_end(){evlink('true','9','Web Registration Complete');}
